/**
 * On touch devices, prevent the first tap on a "has children" nav item from following the link
 * (so it opens the submenu instead), unless the item opts out via `.jet-nav-hover`.
 */
export function initDropdownTouch() {
	const isTouchDevice = 'ontouchstart' in document.documentElement;

	if ( isTouchDevice ) {
		document.body.classList.add( 'touch-device' );
	}

	if ( ! document.body.classList.contains( 'touch-device' ) || window.innerWidth <= 768 ) {
		return;
	}

	document.querySelectorAll( '.menu-item-has-children > a' ).forEach( ( link ) => {
		link.addEventListener( 'click', ( event ) => {
			if (
				! link.parentElement.classList.contains( 'jet-nav-hover' ) &&
				document.body.classList.contains( 'touch-device' )
			) {
				event.preventDefault();
			}
		} );
	} );
}
